import React from "react";
import { useAtom } from "jotai";
import { gamesUserFavoritesAtom } from "../state/games";
import Game from "../components/Game";
import Filters from "../components/Filters";

const FavoritesPage = () => {
    const [games] = useAtom(gamesUserFavoritesAtom);

    return (
        <>
            <Filters />
            <div className="games-section games-favorite">
                <div className="games-inner">
                    <div className="games">
                        {games === null || games.count == 0 ? (
                            <div className="empty-list">
                                <p>You don't have any 'Favourites' yet.</p>
                                <p>
                                    Click on the star symbol you see when hovering above game
                                    thumbnails to fill this section with your preferred games.
                                </p>
                            </div>
                        ) : (
                            games.games.map(game => {
                                return <Game game={game} key={game.id} />;
                            })
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default FavoritesPage;
